import axios from "axios";
import keycloak from "../auth/keycloak";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    // Si Keycloak no está autenticado, no agregamos el token
    if (!keycloak.authenticated) {
      return config; // Si no está autenticado, no agregamos el token
    }

    // Recuperamos el token de acceso almacenado en localStorage
    const storedToken = localStorage.getItem("keycloak-token");

    // Si hay un token en localStorage, lo asignamos a Keycloak
    if (storedToken) {
      keycloak.token = storedToken;
    }

    try {
      // Intentamos actualizar el token si está cerca de expirar (en 30 segundos)
      await keycloak.updateToken(30); // Keycloak maneja el refresh token internamente

      // Si la actualización del token fue exitosa, lo guardamos en localStorage
      localStorage.setItem("keycloak-token", keycloak.token); // Guardamos el nuevo token en localStorage

      // Añadimos el token actualizado al encabezado Authorization
      config.headers.Authorization = `Bearer ${keycloak.token}`;

    } catch (error) {
      console.warn("No se pudo actualizar el token:", error);
      
      // Si el refresh token no está disponible o ha caducado, redirigimos al login
      keycloak.login();
    }

    return config; // Devolvemos la configuración de la solicitud
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;

